import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "status_bar"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "bg_color"
}, null, -1);

const _hoisted_3 = ["onClick"];
import { computed } from "vue";
import useRoute from "@util/router";
export default {
  __name: 'StatusBar',
  props: {
    data: {
      type: Array,
      required: true
    },
    default: {}
  },

  setup(__props) {
    const route = useRoute();
    const props = __props;
    const active = computed(() => {
      return route.query().status || props.default;
    });

    function statusChange(val) {
      route.replaceQuery('status', val);
    }

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          onClick: $event => statusChange(item.value),
          key: index,
          class: _normalizeClass({
            'item': true,
            'active': item.value == active.value
          })
        }, [_createElementVNode("h2", null, _toDisplayString(item.total), 1), _createElementVNode("span", null, _toDisplayString(item.label), 1)], 10, _hoisted_3);
      }), 128))]);
    };
  }

};